module.exports = __webpack_public_path__ + "img/migration-icon-1.32d86668.svg";